import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { environment } from '../../../environments/environment';

/**
 * Guard to prevent access to the FAQ route if the feature is disabled in the environment configuration.
 * If 'environment.passenger.enableFaq' is false, the user is redirected to the home page.
 */
@Injectable({
  providedIn: 'root'
})
export class FaqGuard implements CanActivate {
  constructor(protected router: Router) {}

  /**
   * Checks if the FAQ feature is enabled.
   * @returns true if enabled, otherwise redirects to root and returns false.
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (environment.passenger.application.faq.menuEnabled) {
      return true;
    } else {
      this.router.navigate(['/']);
      return false;
    }
  }
}
